export default {
    path: "/send-push-notifications",
    name: "send-push-notifications.index",
    component: () => import("@/views/PushNotifications.vue"),
};
